import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
  position: relative;
  width: 100%;
  height: auto; // Changed from fixed height to auto
  min-height: 100vh; // Ensure minimum height of viewport
  overflow: hidden;
  margin-top: 16rem;
  margin-bottom: 16rem;
  background: black;
  padding-bottom: 2rem; // Added padding to ensure content isn't cut

  @media (max-width: 768px) {
    min-height: 100vh; // Use min-height instead of fixed height
  }
`;

const VideoBackground = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.8;
  z-index: 1; // Ensure video stays behind content
`;

const ContentOverlay = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  width: 100%;
`;

const ContentContainer = styled.div`
  width: 80%;
  padding: 4rem 0;

  @media (max-width: 768px) {
    width: 90%;
    padding: 2rem 0;
  }
`;

const MainHeadline = styled.h2`
  color: #49abdb;
  font-size: 4.5rem;
  font-weight: bold;
  margin-bottom: 4rem;
  line-height: 1.2;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const BodyParagraph = styled.p`
  color: white;
  font-size: 1.8rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const ScienceCaresSection = styled.div`
  color: #d69de6;
  font-size: 1.8rem;
  margin-top: 4rem;
  text-align: center;
`;

const ScienceCares = styled.p`
  color: white;
  font-weight: bold;
`;

const CommunicationSection = () => {
  return (
    <SectionWrapper>
      <VideoBackground 
        autoPlay 
        muted 
        loop 
        playsInline
      >
        <source src="/videos/vertical.mp4" type="video/mp4" />
      </VideoBackground>

      <ContentOverlay>
        <ContentContainer>
          <MainHeadline>
            WE ARE MEDICINE<br/>
            THROUGH COMMUNICATION
          </MainHeadline>

          <BodyParagraph>
            HEARTPORT brings scientific knowledge to where it can make a difference, into clinical practice, prevention and people's everyday lives.
          </BodyParagraph>
          <BodyParagraph>
            Through our digital platforms, scientific initiatives and conferences, we connect research with those who can use it: doctors, scientists, patients and the public.
          </BodyParagraph>

          <ScienceCaresSection>
            <p>Because,</p>
            <ScienceCares>SCIENCE CARES</ScienceCares>
          </ScienceCaresSection>
        </ContentContainer>
      </ContentOverlay>
    </SectionWrapper>
  );
};

export default CommunicationSection;
